const dataApi = [

    {
        "id": 1,
        "model": "Nokia 106",
        "colors": "Dark Grey",
        "salesPackage": "Device Nokia, MicroUSB charger, Charging / data cable, Quick guide",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595434281/Nokia%20106/HMD_Nemo_Front_Bubbles_Lock_Large_Alpha_16092018_kkvdap.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595434282/Nokia%20106/HMD_Nemo_ALE_Bubbles_Home_Large_Alpha_16092018_livjqv.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595434282/Nokia%20106/HMD_Nemo_ARI_Bubbles_Lock_Large_Alpha_16092018_hnodpy.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595434282/Nokia%20106/HMD_Nemo_Back_Large_Alpha_16092018_ybj2ev.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595434281/Nokia%20106/HMD_Nemo_Side_Large_Alpha_16092018_lm7x2b.png"
        ],
        "dimension": "",
        "networks": "GSM 900/1800(EU)",
        "os": "S30+",
        "variant": "Dual SIM only",
        "cpu": "MTK 6261D",
        "storage": "4MB ROM 4MB RAM integrated in chipset",
        "camera": "",
        "formFactor": "ITUT",
        "display": "1.8QQVGA ( = 1.77)",
        "connectivitySensors": "Micro USB (USB 2.0), 3.5mm AHJ",
        "battery": "Removable 800 mAh battery",
        "talkAndStandby": "Up to 15.7hrs/21.9days Talk/Standby time",
        "audio": "FM Radio (Headset required)",
        "torch": "Yes",
        "dimensions": "Estimated 112 x 49.5 x 14.4mm",
        "simCardType": "2FF (Mini Sim)"
    },
    {
        "id": 2,
        "model": "Nokia 210",
        "colors": "Charcoal, Red and Grey",
        "salesPackage": "Nokia 210, Nokia Micro USB, charger (550 mAh), Quick start guide, Headset",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598884313/Nokia%20210/Outrun_Rational_Front_Black_China_PNG_kzwnwt.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598884313/Nokia%20210/Outrun_Rational_Front_Quarter_Left_Black_JPG_zkwe6q.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598884314/Nokia%20210/Outrun_Rational_Front_Quarter_Right_Grey_China_PNG_coga9i.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598884314/Nokia%20210/Outrun_Rational_Front_Quarter_Left_Grey_JPG_pmugjs.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598884315/Nokia%20210/Outrun_Rational_Front_Red_JPG_egx1qc.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598884315/Nokia%20210/Outrun_Rational_Front_Quarter_Right_Red_PNG_jmedbs.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598884313/Nokia%20210/Outrun_Rational_Front_Quarter_Left_Red_JPG_wk6hcg.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598884313/Nokia%20210/Outrun_Rational_Back_Red_l744kp.png"
        ],
        "networks": "GSM 900/1800",
        "os": "S30+",
        "variant": "Dual SIM only",
        "cpu": "MTK 6260A",
        "storage": "16 MB",
        "camera": "VGA",
        "formFactor": "",
        "display": "2.4” QVGA",
        "connectivitySensors": "Micro USB, 3.5mm AHJ",
        "battery": "Removable BL-5C 1020 mAh battery",
        "talkAndStandby": "Up to 18 hours, Up to 20 days",
        "audio": "FM radio, MP3 player",
        "torch": "",
        "dimensions": "120.8 x 53.49 x 13.81 mm",
        "simCardType": "2FF (Mini Sim)"
    },
    {
        "id": 3,
        "model": "Nokia 5310",
        "colors": "White and Black",
        "salesPackage": "Device, Battery, Nokia Micro USB charger (550 mAh), Quick guide, Headset",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_White_Front_PNG_ld5kik_c9wk58.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_White_RHS_45_PNG_mqrorx_ok9ntq.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_White_LHS_45_PNG_aljta0_ar8ffi.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_White_Back_PNG_zfgkdg_kqykyy.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_White_RHS_PNG_vw0c2y_evk3hb.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_Black_Front_PNG_msa3bi_tenbx0.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_Black_RHS_45_PNG_dzwwso_p20ths.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_Black_Back_PNG_lnjgdo_s2y0d6.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267595/Nokia%205310/Large-Pisces_Rationals_Black_RHS_PNG_lhtyav_jnophg.png"
        ],
        "networks": "GSM 900/1800",
        "os": "S30+",
        "variant": "",
        "cpu": "MT6260A",
        "storage": "16MB (ROM) + 8MB (RAM); Memory card slot expandable upto 32GB",
        "camera": "",
        "formFactor": "",
        "display": "2.4” QVGA",
        "connectivitySensors": "Micro USB (USB 1.1), 3.5mm",
        "battery": "Removable 1200 mAh battery",
        "talkAndStandby": "Up to 20.7 hours talk time and up to 30 days standby time. (Single SIM). Up to 20.7 hours talk time and up to 22 days standby time (Dual SIM)",
        "audio": "Dual speakers, FM Radio (wired+wireless), MP3/3G2/3GP/AMR player",
        "torch": "",
        "dimensions": "123.7mm x 52.4mm x 13.1mm",
        "simCardType": "Single SIM / Dual SIM / 2FF"
    },
    {
        "id": 4,
        "model": "Nokia 3310",
        "colors": "",
        "salesPackage": "Nokia 3310 device. Quick start guide. Battery: BL-5C (1200 mAh). Micro-USB Charger. Headset WH-108",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267260/Nokia%203310/Retro_Rational_Yellow_Front_SSIM_risultato_vehgrp__gblntu.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267261/Nokia%203310/Retro_Rational_Yellow_Back_risultato_pticr7_2_luk4_cgoy07.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267260/Nokia%203310/Retro_Rational_Yellow_Side_risultato_q3nlye_bgumir_kduqwl.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267260/Nokia%203310/Retro_Rational_WarmRed_Front_SSIM_risultato_ikj7dv_pvfyyi.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267260/Nokia%203310/Retro_Rational_WarmRedBack_risultato_hwvn3v_wj1wkq_vkaby8.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267260/Nokia%203310/Retro_Rational_WarmRedSide_risultato_ckmmmk_ndxxlz_yfvhgs.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267259/Nokia%203310/Retro_Rational_Grey_Front_DSIM_risultato_x8squh_wj_bwwsyp.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267259/Nokia%203310/Retro_Rational_GreyBack_risultato_a3medz_zjixoy_cdfkp0.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267259/Nokia%203310/Retro_Rational_GreySide_risultato_zoglqz_r1sxwq_jzwfk9.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267259/Nokia%203310/Retro_Rational_Dark_Blue_Front_SSIM_risultato_l5iu_yxnxyh.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267259/Nokia%203310/Retro_Rational_Dark_Blue_Back_risultato_mhvhw6_e4n_kau5by.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267259/Nokia%203310/Retro_Rational_Dark_Blue_Side_risultato_d773dp_krp_y3c9ke.png"
        ],
        "networks": "",
        "os": "",
        "variant": "",
        "cpu": "",
        "storage": "MicroSD card support up to 32 GB",
        "camera": "2Mpxl camera with LED flash",
        "formFactor": "",
        "display": "2.4\" QVGA (240*320)",
        "connectivitySensors": "micro USB, 3.5mm AV connector, Bluetooth 3.0 with SLAM",
        "battery": "",
        "talkAndStandby": "Standby time: up to 25.3 days. Talk time: up to 22.1 hours. MP3 playback up to 51 hours (volume 5). FM radio playback up to 39 hours",
        "audio": "",
        "torch": "Yes",
        "dimensions": "115.6 x 51.0 x 12.8mm",
        "simCardType": "Dual SIM"
    },
    {
        "id": 5,
        "model": "Nokia 8110",
        "colors": "",
        "salesPackage": "",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433269/Nokia%208110%204G/Argon_Rationals_3000px_00066_ejogjh.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433267/Nokia%208110%204G/Argon_Rationals_3000px_00095_q3xwyz.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433268/Nokia%208110%204G/Argon_Rationals_3000px_00067_pmgpzy.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433268/Nokia%208110%204G/Argon_Rationals_3000px_00069_ql2tbd.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433266/Nokia%208110%204G/Argon_Rationals_3000px_00092_x9l5b1.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433268/Nokia%208110%204G/Argon_Rationals_3000px_00084_ootztg.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433268/Nokia%208110%204G/Argon_Rationals_3000px_00089_gpdz6a.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433266/Nokia%208110%204G/Argon_Rationals_3000px_00085_dencvl.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433268/Nokia%208110%204G/Argon_Rationals_3000px_00087_mmdh8o.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433269/Nokia%208110%204G/Argon_Rationals_3000px_00062_iz4eku.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433361/Nokia%208110%204G/Argon_Rationals_3000px_00006_y1xkp8.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433359/Nokia%208110%204G/Argon_Rationals_3000px_00011_r4nslf.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433361/Nokia%208110%204G/Argon_Rationals_3000px_00033_ssfo6p.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433359/Nokia%208110%204G/Argon_Rationals_3000px_00032_eccchu.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433359/Nokia%208110%204G/Argon_Rationals_3000px_00024_tp21mq.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433363/Nokia%208110%204G/Argon_Rationals_3000px_00005_aysukt.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433360/Nokia%208110%204G/Argon_Rationals_3000px_00025_nxlxvz.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1595433363/Nokia%208110%204G/Argon_Rationals_3000px_00003_vwwqea.png"
        ],
        "networks": "",
        "os": "KaiOS",
        "variant": "",
        "cpu": "CPU MSM8905 Dual Core 1.1 GHz",
        "storage": "4GB Internal Storage and RAM 512 MB",
        "camera": "2 MP camera with LED flash",
        "formFactor": "",
        "display": "2.4\" curved screen",
        "connectivitySensors": "4G",
        "battery": "",
        "talkAndStandby": "Standby time (4G) Up to 25 days",
        "audio": "3.5mm audio jack",
        "torch": "",
        "dimensions": "",
        "simCardType": ""
    },
    {
        "id": 6,
        "model": "Nokia 800 Tough",
        "colors": "Black Steel | Desert Sand",
        "salesPackage": "Nokia 800 Tough | Charger | USB Cable | Quick Start Guide",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267882/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Black_FRN_SS-HS_jpg_qxehzx_rcqsyp.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267882/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Black_FRN-45-RHS_SS-LS_jpg_xd2fkf.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267882/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Black_FRN-45-LHS_DS-HS_jpg_oul2pm.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267882/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Black_BCK_jpg_dkukue_v7lwes.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267882/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Black_LHS_jpg_getvpm_xae0ru.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267883/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Sand_FRN_SS-LS_JPG_kzkfbe_dqgnvn.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267883/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Sand_FRN-45-RHS_SS-HS_JPG__ojxiob.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267883/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Sand_FRN-45-LHS_SS-HS_JPG__t5x6bm.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267882/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Sand_BCK_JPG_qqyccd_av3flo.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599267883/Nokia%20800%20Tough%20Nokia%20800%20Tough/Large-Coconut_Rationals_Sand_LHS_JPG_zgx8gm_ulgrw7.png"
        ],
        "networks": "LTE Cat 4 - 150Mbps DL/50Mbps UL | VoLTE | VoWiFi",
        "os": "KaiOS",
        "variant": "",
        "cpu": "Qualcomm® 205 Mobile Platform",
        "storage": "512MB LPDDR3, 4GB eMMC , Micro SD supports (up to 32GB)",
        "camera": "2MP + Flash",
        "formFactor": "",
        "display": "2.4” (6.1 cm) QVGA",
        "connectivitySensors": "802.11 b/g/n , Bluetooth 4.1 , GPS/AGPS , FM Radio",
        "battery": "2100mAh (Typ.) non-removable",
        "talkAndStandby": "Single Sim: Standby time up to: GSM 43.7 days, 3G 43.0 days, 4G 34.0 days. Talk time up to: GSM 12.5 hours, 3G 14.3 hours, 4G 9.4 hours. Dual Sim: Standby time up to: GSM 36.2 days, 3G 30.4 days, 4G 22.4 days. Talk time up to: GSM 12.5 hours, 3G 14.3 hours, 4G 9.4 hours",
        "audio": "3.5mm audio jack",
        "torch": "Yes",
        "dimensions": "16.11 x 62.1 x 145.4",
        "simCardType": "2 Nano SIM or 1 Nano Sim + SD slot"
    },
    {
        "id": 7,
        "model": "Nokia 2720 Flip",
        "colors": "Black | Grey",
        "salesPackage": "",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266038/Nokia%202720%20Flip/Beatles_Rationals_Grey_Open_DS-HS_FRN_JPG_zbetwp_lyrlpn.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266038/Nokia%202720%20Flip/Beatles_Rationals_Grey_Open_DS-HS_RHS-45-FRN_JPG_x_mw8vs8.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266039/Nokia%202720%20Flip/Beatles_Rationals_Grey_Open_SS-HS_LHS-45-FRN_JPG_r_kj8ssf.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266038/Nokia%202720%20Flip/Beatles_Rationals_Grey_Open_BCK_JPG_kgm3vg_vcxhtw.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266038/Nokia%202720%20Flip/Beatles_Rationals_Grey_Open_RHS_JPG_rvb4rh_gux5m2.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266038/Nokia%202720%20Flip/Beatles_Rationals_Grey_Closed_FRN_JPG_z8y2s8_qbzasa.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266038/Nokia%202720%20Flip/Beatles_Rationals_Grey_Closed_BCK_JPG_hdcuh0_vmyhzf.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266038/Nokia%202720%20Flip/Beatles_Rationals_Grey_Closed_LHS_JPG_rte0z5_sefyco.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266037/Nokia%202720%20Flip/Beatles_Rationals_Black_Open_DS-HS_RHS-45-FRN_JPG__exxufv.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266037/Nokia%202720%20Flip/Beatles_Rationals_Black_Open_DS-HS_LHS-45-FRN_JPG__lqefyi.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266037/Nokia%202720%20Flip/Beatles_Rationals_Black_Open_BCK_JPG_xiosw2_uflssm.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266037/Nokia%202720%20Flip/Beatles_Rationals_Black_Open_LHS_JPG_m1ntal_iwfmed.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266037/Nokia%202720%20Flip/Beatles_Rationals_Black_Closed_FRN_JPG_xghfum_rmhemz.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599266037/Nokia%202720%20Flip/Beatles_Rationals_Black_Closed_RHS_JPG_jqpire_ckyh1c.png"
        ],
        "networks": "LTE Cat 4 - 150Mbps DL/50Mbps UL | VoLTE2 | VoWi-Fi",
        "os": "KaiOS",
        "variant": "Single SIM and Dual SIM (Nano SIM",
        "cpu": "Qualcomm 205 Mobile Platform",
        "storage": "RAM: 512MB, ROM: 4GB3 + extendable microSD card slot supports up to 32GB",
        "camera": "2MP + flash",
        "formFactor": "",
        "display": "2.8” (7.1 cm) QVGA + 1.3” (3.3 cm) 240x240",
        "connectivitySensors": "Wi-Fi WLAN IEEE 802.11 b/g/n,  Location: GPS/AGPS + GLONASS  Bluetooth® 4.1, A2DP, AVRCP, DUN, FTP, HFP, HID, HSP, MAP, OPP, PBAP, PAN, IOPT  Micro USB (USB 2.0), 3.5mm AHJ HAC (Hearing Aid Compatible)",
        "battery": "Removable BL-6V 1500 mAh",
        "talkAndStandby": "Single Sim: Standby time up to: GSM 27.8 days, 3G 28.9 days, 4G 20.9 days | Talk time up to: GSM 8.9 hours, 3G 10.9 hours, 4G 6.6 hours. Dual Sim: Standby time up to: GSM 19.3 days, 3G 18.2 days, 4G 14.0 days | Talk time up to: GSM 8.9 hours, 3G 10.9 hours, 4G 6.6 hours",
        "audio": "",
        "torch": "Yes",
        "dimensions": "Closed: 54.5 mm x 104.8 mm x 18.7 mm Open: 54.5 mm x 192.7 mm x 11.6 mm",
        "simCardType": "Single SIM and Dual SIM (Nano SIM)"
    },
    {
        "id": 8,
        "model": "Nokia 105",
        "colors": "",
        "salesPackage": "",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258767/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Pink_Rationals_DS_FRONT_hgf7l_ry09bz.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258767/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Pink_Rationals_DS_FRONT_QTR_R_l386kf.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258767/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Pink_Rationals_SS_FRONT_QTR_L_knletx.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258766/Nokia%20105%20%28King%29/HMD_Nokia_King_Pink_Rationals_BACK_k5kgec_oiabfw.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258767/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Blue_Rationals_SS_FRONT_qlqsh_c9pamp.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258767/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Blue_Rationals_DS_FRONT_QTR_R_oawju7.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258767/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Blue_Rationals_SS_FRONT_QTR_L_pns6ex.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258766/Nokia%20105%20%28King%29/HMD_Nokia_King_Blue_Rationals_BACK_hqboqs_zqzbub.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258766/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Black_Rationals_DS_FRONT_nvil_z4veck.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258766/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Black_Rationals_DS_FRONT_QTR__ivutcb.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258766/Nokia%20105%20%28King%29/Mirum_HMD_Nokia_King_Black_Rationals_SS_FRONT_QTR__yhmmyi.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599258766/Nokia%20105%20%28King%29/HMD_Nokia_King_Black_Rationals_BACK_bmmfnt_epljl8.png"
        ],
        "networks": "GSM 900/1800(EU) 850/1900(US)",
        "os": "S30+",
        "variant": "Dual SIM / Single SIM",
        "cpu": "",
        "storage": "4MB RAM 4MB ROM",
        "camera": "",
        "formFactor": "ITUT",
        "display": "1.8\" QQVGA",
        "connectivitySensors": "Micro USB (USB 2.0), 3.5mm AHJ",
        "battery": "Removable 800 mAh battery",
        "talkAndStandby": "Standby time: Up to 30 days.s Dual SIM Standby time: Up to 21 days. Talk time: Up to 15hrs",
        "audio": "FM Radio",
        "torch": "",
        "dimensions": "112.0 x 49.45 x 14.4mm",
        "simCardType": "2FF (mini SIM)"
    },
    {
        "id": 9,
        "model": "Nokia 130",
        "colors": "Red, Grey, Black",
        "salesPackage": "Nokia 130 device | Quick start guide | Micro USB charger | Charging/data cable",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261281/Nokia%20130%20Kesa/Large-Nokia_Grey_Rational_Front_SS_300DPI_lqjbnd_hu10sz.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261281/Nokia%20130%20Kesa/Large-Nokia_Grey_Rational_3Qrtrs_DS_300DPI_sbj5jf_kxyu5a.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261281/Nokia%20130%20Kesa/Large-Nokia_Grey_Rational_Back_300DPI_kej9o5_xrfaoz.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261282/Nokia%20130%20Kesa/Large-Nokia_Red_Rational_Front_SS_300DPI_rkalqt_jo5dwk.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261282/Nokia%20130%20Kesa/Large-Nokia_Red_Rational_3Qtrs_SS_300DPI_btngns_efrd8t.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261282/Nokia%20130%20Kesa/Large-Nokia_Red_Rational_Back_300DPI_auggke_nm1a0n.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261281/Nokia%20130%20Kesa/Large-Nokia_Black_Rational_Front_SS_300DPI_erchi0_f2my7e.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261281/Nokia%20130%20Kesa/Large-Nokia_Black_Rational_3Qtrs_SS_300DPI_n9kwbd_a4vcma.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599261281/Nokia%20130%20Kesa/Large-Nokia_Black_Rational_Back_300DPI_wrz9yg_xqxdiu.png"
        ],
        "os": "S30+",
        "variant": "",
        "cpu": "",
        "storage": "8MB ROM plus microSD-slot (up to 32GB support)",
        "camera": "VGA Camera",
        "formFactor": "",
        "display": "1.8\" QQVGA",
        "connectivitySensors": "Micro USB (USB 2.0), 3.5mm AHJ, BT v3.0",
        "battery": "Removable 1020 mAh battery",
        "talkAndStandby": "",
        "audio": "",
        "torch": "",
        "dimensions": "111.5 x 48.4 x 14.2mm",
        "simCardType": "mini SIM"
    },
    {
        "id": 10,
        "model": "Nokia 216",
        "colors": "",
        "salesPackage": "",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886455/Nokia%20216/SUE_RTN_BLUE_FRT_FIN_V03_nslimi.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886454/Nokia%20216/SUE_RTN_BLUE_BAC_FIN_V03_olaltf.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886454/Nokia%20216/SUE_RTN_BLUE_RGT_FIN_V03_tsdzg6.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886455/Nokia%20216/SUE_RTN_GREY_FRT_FIN_V03_saozuw.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886455/Nokia%20216/SUE_RTN_GREY_BAC_FIN_V03_qcouon.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886455/Nokia%20216/SUE_RTN_GREY_RGT_FIN_V03_mntmw2.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886454/Nokia%20216/SUE_RTN_BLAK_FRT_FIN_V03_fiixh9.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886454/Nokia%20216/SUE_RTN_BLAK_BAC_FIN_V03_jwrdw2.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1598886454/Nokia%20216/SUE_RTN_BLAK_RGT_FIN_V03_rf0r7e.png"
        ],
        "networks": "GSM network: 900 MHz, 1800 MHz",
        "os": "Series 30+",
        "variant": "",
        "cpu": "",
        "storage": "RAM: 16 MB, Maximum memory card size: 32 GB",
        "camera": "VGA 0.3 MP",
        "formFactor": "",
        "display": "Display size: 2.4 \"(6.09 cm)",
        "connectivitySensors": "",
        "battery": "Removable 1020 mAh battery",
        "talkAndStandby": "Talk: Up to 18 hours; Standby: Up to 19 days",
        "audio": "Stereo FM Radio , MP3 player",
        "torch": "",
        "dimensions": "118 mm X 50.2 mm X 13.5 mm (Weight 82.6 g)",
        "simCardType": ""
    },
    {
        "id": 11,
        "model": "Nokia 110",
        "colors": "Ocean Blue, Pink, Black",
        "salesPackage": "Nokia 110 device | Quick start guide | Micro USB charger",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260788/Nokia%20110/Large-Nickel_Black_Rationals_FRONT_jpg_xv3d0q_kby6o1.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260788/Nokia%20110/Large-Nickel_Black_Rationals_FRONT_RHS_45_jpg_lrle_x2hbko.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260788/Nokia%20110/Large-Nickel_Black_Rationals_BACK_jpg_ydurjj_j2epgu.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260788/Nokia%20110/Large-Nickel_Black_Rationals_SIDE_RIGHT_jpg_isjjg7_rulsbb.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260788/Nokia%20110/Large-Nickel_Ocean_Blue_Rationals_FRONT_LHS_45_jpg_wktneb.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260789/Nokia%20110/Large-Nickel_Ocean_Blue_Rationals_FRONT_RHS_45_jpg_vygxtb.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260788/Nokia%20110/Large-Nickel_Ocean_Blue_Rationals_BACK_jpg_ypfs1v_wvrsfl.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260788/Nokia%20110/Large-Nickel_Ocean_Blue_Rationals_SIDE_RIGHT_jpg_t_mkw9er.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260789/Nokia%20110/Nickel_PInk_Rationals_FRONT_LHS_45_jpg_pexvln_xjtpnv.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260789/Nokia%20110/Nickel_Pink_Rationals_FRONT_RHS_45_jpg_acnze5_olrxwj.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260788/Nokia%20110/Large-Nickel_Pink_Rationals_BACK_jpg_hikzid_yixbvo.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599260789/Nokia%20110/Large-Nickel_Pink_Rationals_SIDE_RIGHT_jpg_vrnwea_xwa23v.png"
        ],
        "networks": "GSM 900/1800 (EU)",
        "os": "Series 30+",
        "variant": "",
        "cpu": "SPRD 6531E",
        "storage": "Internal storage 4 MB, MicroSD card slot Support for up to 32 GB",
        "camera": "Rear camera type QVGA",
        "formFactor": "",
        "display": "Display size: 1.77” QQVGA",
        "connectivitySensors": "Micro USB (USB 2.0), SIM cards Dual SIM",
        "battery": "800 mAh removable",
        "talkAndStandby": "Talk: up to 14 hours; Standby: up to 18.5 days",
        "audio": "FM Radio, 3.5 mm headphone jack",
        "torch": "",
        "dimensions": "115.15 x 49.85 x 14.3mm",
        "simCardType": "Mini-SIM"
    },
    {
        "id": 12,
        "model": "Nokia 220",
        "colors": "Blue, Black",
        "salesPackage": "Device | Quick start guide | Micro USB charger (550mAh)",
        "pictures": [
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599265005/Nokia%20220/HMD_Nokia_Queen_Rationals_Blk_Front_SSIM_R11_hrh3i_xgbqhz.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599265005/Nokia%20220/Mirum_HMD_Nokia_Queen_Rationals_Blk_RHS_45_DSIM_R1_liinti.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599265005/Nokia%20220/Mirum_HMD_Nokia_Queen_Rationals_Blk_LHS_45_SSIM_R1_xp5f7l.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599265004/Nokia%20220/Mirum_HMD_Nokia_Queen_Rationals_Blk_Back_R11_snzqx_muox1m.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599265005/Nokia%20220/Mirum_HMD_Nokia_Queen_Rationals_Blue_Front_DSIM_R1_rxozve.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599265005/Nokia%20220/Mirum_HMD_Nokia_Queen_Rationals_Blue_RHS_45_SSIM_R_gksmoj.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599265004/Nokia%20220/HMD_Nokia_Queen_Rationals_Blue_LHS_45_DSIM_R11_v6w_pe9hrw.png",
            "https://res.cloudinary.com/dw4g9x8wv/image/upload/v1599265005/Nokia%20220/Mirum_HMD_Nokia_Queen_Rationals_Blue_Back_R11_x89f_cdyloa.png"
        ],
        "networks": "GSM/GPRS 900/1800 R13, LTE Cat-1 bis 10Mbps DL + 5Mbps UL 4G with 2G fall back (No 3G)",
        "os": "Feature OS",
        "variant": "SS / DS",
        "cpu": "SPRD 8910",
        "storage": "24MB + 16MB",
        "camera": "Rear: VGA",
        "formFactor": "",
        "display": "2.4” QQVGA",
        "connectivitySensors": "Micro USB (USB 2.0), 3.5mm AHJ, BT 4.2",
        "battery": "Removable 1200 mAh battery",
        "talkAndStandby": "Talk: Up to 6.3 hours; Standby: Up to 27 days",
        "audio": "FM Radio (Wired and Wireless dual mode), MP3 player",
        "torch": "",
        "dimensions": "121.3mm X 52.9mm X 13.4mm (Weight 86.5g)",
        "simCardType": "4FF Nano (primary) + 2FF Mini (2nd SIM) (LTE+LTE dual standby)"
    }

]

export default dataApi; 